import TNLogo from "../../../../assets/images/TNLogoQuote.png";
import { Table } from "antd";
import DummySignature from "../../../../assets/images/mock_signature.png";
import { QuoteContents } from "../../CreateJobView/BuildQuote/constant";
import CreateJobServices from "../../../../services/createJob.services";
import { useEffect, useMemo } from "react";
import styles from "./ViewQuote.module.scss";
import { QuoteFields, ImgAltTexts, getColumns, getDocumentRows } from "./constants.tsx";
import { TruckMaterialType } from "../../../../enums/truckMaterialType";
import TNLoader from "../../../../reusable-components/TNLoader";
import ConditionalRender from "../../../../reusable-components/ConditionalRender";
import DocumentServices from "../../../../services/documents.services";
import { documentType } from "../../../Documents/constants";
import clsx from "clsx";

const ViewQuote = ({ jobLeadData }) => {
  const {
    email,
    phone,
    printname,
    title,
    date,
    paymentHeader,
    signatureHeader,
    signedFor,
    signedForTn,
    address1,
    address2,
    address3,
    header,
    locationInfo,
  } = QuoteFields;
  const { logoAltText, signatureAltText } = ImgAltTexts;
  const columns = getColumns();
  const { FetchQuote } = CreateJobServices();
  const { FetchDocumentDetails } = DocumentServices();
  const {
    data: quotesFields,
    isFetching,
    refetch,
  } = FetchQuote(jobLeadData?.id);
  const { data: templateDocData, refetch: refetchTemplates } =
      FetchDocumentDetails({
        isCrm: true
      });
  const quoteTemplateRows = useMemo(
    () => getDocumentRows(templateDocData, documentType.quote)?.find((item) => item.isPrimary),
    [templateDocData]
  );
  const { DESCRIPTION, PAYMENT, SIGNATURE } = QuoteContents;
  const imgURL = quotesFields?.img_url?.split("?")[0];
  const materialTruckList = jobLeadData?.material
    ?.filter((item) => item?.type === TruckMaterialType.MATERIAL_TYPE)
    ?.map((item: MaterialTruck) => ({
      ...item,
      vendorName: item?.vendor,
      materialTruckName: item?.materialName,
      materialCost: item?.materialCost,
      quantity: item?.materialQuantity,
      quantityUnitType: item?.materialQuantityUnitType,
      materialPrice: item?.materialPrice,
      truckingCost: item?.truckingCost,
      truckingPrice: item?.truckingPrice,
      truckType: item?.truckType,
      materialCostType: item?.materialCostType,
      materialPriceType: item?.materialPriceType,
      truckingCostType: item?.truckingCostType,
      truckingPriceType: item?.truckingPriceType,
      isBlocked: item?.isBlocked,
    }));

  const truckDetails = jobLeadData?.material
    ?.filter((item) => item?.type === TruckMaterialType.TRUCK_TYPE)
    ?.map((item) => {
      return {
        ...item,
        pickupLocation: item?.pickUpAddress,
        deliveryLocation: item?.pickUpAddress,
        milesDuration: item?.milesData?.text,
        truckType: item?.truckType,
        materialTruckName: item?.materialName,
        truckingCost: item?.truckingCost,
        truckingPrice: item?.truckingPrice,
        vendorName: item?.vendor,
        materialCost: item?.materialCost,
        quantity: item?.truckingQuantity,
        quantityUnitType: item?.truckingQuantityUnitType,
        materialCostType: item?.materialCostType,
        materialPriceType: item?.materialPriceType,
        truckingCostType: item?.truckingCostType,
        truckingPriceType: item?.truckingPriceType,
        isBlocked: item?.isBlocked,
      };
    });

  const dataSource = [
    ...(materialTruckList?.map((item, idx) => ({
      ...item,
      _key: `material-${item.id}-${idx}`,
    })) ?? []),
    ...(truckDetails?.map((item, idx) => ({
      ...item,
      _key: `truck-${item.id}-${idx}`,
    })) ?? []),
  ]?.filter((item) => item?.isBlocked !== true);

  useEffect(() => {
    refetch();
    refetchTemplates();
  }, [jobLeadData?.id]);

  return (
    <>
      <TNLoader isLoading={isFetching} />
      <div className={styles.QuoteBody}>
        <div className={styles.LogoAddressContainer}>
          <div>
            <img
              src={TNLogo}
              alt={logoAltText}
              className={styles.TwistedNailsLogo}
            />
          </div>
          <div className={styles.AddressContainer}>
            <h5>{quotesFields?.companyName ?? quoteTemplateRows?.companyName}</h5>
            <h4>{quotesFields?.companyAddress ?? quoteTemplateRows?.companyAddress}</h4>
            <h4>{quotesFields?.companyContact ?? quoteTemplateRows?.companyContact}</h4>
          </div>
        </div>
      </div>
      <div className={styles.SubHeadingContainer}>
        <h1>{quotesFields?.quoteHeade ?? quoteTemplateRows?.quoteHeader}</h1>
        <div className={styles.SubHeadingContent}>
          <h5>{quotesFields?.quoteAddressTerms ?? quoteTemplateRows?.quoteAddressTerms}</h5>
          <div className={styles.locationContent}>
            <h3>{jobLeadData?.dropoff ?? ""}</h3>
          </div>
        </div>
      </div>
      <div className={styles.TableContainer}>
        <Table
          columns={columns}
          dataSource={dataSource}
          pagination={false}
          rowKey={(record) => record._key}
        />{" "}
      </div>
      <div className={styles.TextContentContainer}>
        <div className={styles.FirstTextContainer}>
          <p>{quotesFields?.quote_agreementDescription ?? quoteTemplateRows?.mainDescription}</p>
        </div>
        <div className={styles.FirstTextContainer}>
          <h3>{paymentHeader}</h3>
          <p>{quotesFields?.quote_paymemtTerms ?? quoteTemplateRows?.paymentTerms}</p>
        </div>
        <div className={styles.FirstTextContainer}>
          <h3>{signatureHeader}</h3>
          <p>{quotesFields?.quote_signature ?? quoteTemplateRows?.paymentTerms}</p>
        </div>
      </div>
      <div className={styles.SignaturesContainer}>
        <div className={styles.LeftContainer}>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.UnderLine}>
              <ConditionalRender visible={!!imgURL}>
                <img
                  src={imgURL}
                  alt={signatureAltText}
                  className={styles.TNSignature}
                />
              </ConditionalRender>
            </div>
            <h1>{signedForTn}</h1>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <span>{printname}</span>
              {quotesFields?.quote_print_name ?? ""}
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <span>{title}</span>
              {quotesFields?.quote_title ?? ""}
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <span>{phone}</span>
              {quotesFields?.quote_phone ?? ""}
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <span>{email}</span>
              {quotesFields?.quote_email ?? ""}
            </div>
          </div>
        </div>
        <div className={styles.CenterContainer}>
          <div className={clsx(styles.UnderLineEmpty, {
            [styles.extraMargin]: !!!quotesFields?.quote_date
          })}>
            <p>{quotesFields?.quote_date ?? " "}</p>
            <div className={styles.UnderLine}></div>
            <h1>{date}</h1>
          </div>
        </div>
        <div className={styles.RightContainer}>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.UnderLine}> </div>
            <h1>{signedFor}</h1>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <h1>{printname}</h1>
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <h1>{title}</h1>
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <h1>{phone}</h1>
            </div>
          </div>
          <div className={styles.UnderLineEmpty}>
            <div className={styles.FullLine}>
              {" "}
              <h1>{email}</h1>
            </div>
          </div>
        </div>
        <div className={styles.CenterContainer}>
          <div className={clsx(styles.UnderLineEmpty, styles.extraMargin)}>
            <div className={styles.UnderLine}></div>
            <h1>{date}</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewQuote;
